export const TASK_STATUS_INTERVAL = 2000
